import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import ComplementaryActivityDefault from './Default';
import ComplementaryActivityPlayful from './Playful';

export function ComplementaryActivity(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();

  return isPlayfulStudentTheme ? <ComplementaryActivityPlayful {...props} /> : <ComplementaryActivityDefault {...props} />;
}
